import { CarriedInterestAllocationMethod } from '../../../utils/capital-account/utils';
import { CarriedInterestSelectorDataDTO } from './CarriedInterestSelectorDataDTO';

export class CarriedInterestSelectorData {
  public constructor(
    public uuid: string,
    public selectedAllocationMethod: CarriedInterestAllocationMethod,
    public manualPct: number,
  ) {}

  public toDTO(): CarriedInterestSelectorDataDTO {
    return new CarriedInterestSelectorDataDTO(this.uuid, this.selectedAllocationMethod, this.manualPct);
  }
}
